import RpcService from '../helpers/RpcService';
import RpcTypes from '../constants/rpcTypes';

const toggleFeatureToMerchant = async (featureId: number, merchantIds: number[], enabled: boolean = true): Promise<any> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Feature_ToggleMerchants,
        payload: {
          featureId,
          merchantIds,
          enabled
        }
      },
    ],
  });
};

const toggleFeatureToProject = async (featureId: number, projectIds: number[], enabled: boolean = true): Promise<any> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Feature_ToggleProjects,
        payload: {
          featureId,
          projectIds
        }
      },
    ],
  });
};

const toggleFeatureToUser = async (featureId: number, userIds: number[], enabled: boolean = true): Promise<any> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.Feature_ToggleUsers,
        payload: {
          featureId,
          userIds,
          enabled
        }
      },
    ],
  });
};

export {
  toggleFeatureToMerchant,
  toggleFeatureToProject,
  toggleFeatureToUser
}